import AppImage from '@/components/ui/AppImage';
 import Link from'next/link';

interface CaseStudyCardProps {
  id: string
  title: string
  category: string
  image: string
  imageAlt: string
  slug: string
}

export default function CaseStudyCard({ 
  id, 
  title, 
  category, 
  image, 
  imageAlt, 
  slug 
}: CaseStudyCardProps) {
  return (
    <Link 
      href={`/case-studies/${slug}`}
      className="reveal card-hover group block border border-border hover:border-primary transition-all duration-500"
    >
      <div className="image-zoom aspect-[3/4] bg-muted overflow-hidden">
        <AppImage
          src={image}
          alt={imageAlt}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-6 bg-card">
        <span className="text-[9px] uppercase tracking-ultra-wide text-primary mb-2 block font-medium">
          {category}
        </span>
        <h3 className="text-xl font-semibold tracking-tight text-card-foreground group-hover:text-primary transition-colors">
          {title}
        </h3>
      </div>
    </Link>
  )
}